import { TranslatePipe } from '@ngx-translate/core';

import { Component } from '@angular/core';

import { Button } from '@/app/shared/components/ui/button';
import { Dialog, DialogBase, DialogFooter, DialogHeader, DialogContent } from '@/app/shared/components/ui/dialog';

import { Confirm } from './types';

@Component({
  selector: 'app-confirm-dialog',
  standalone: true,
  imports: [TranslatePipe, Dialog, DialogHeader, DialogContent, DialogFooter, Button],
  templateUrl: './confirm-dialog.html',
  styleUrl: './confirm-dialog.scss',
})
export class ConfirmDialog extends DialogBase<Confirm, boolean> {
  constructor() {
    super();

    this.dialogRef.updateSize(this.data.width ?? '520px');
  }

  protected apply() {
    this.dialogRef.submit(true);
  }
}
